import { dtsAPI } from "../../axios";

export const actions = {

    // Document Type
    GetDocumentType(context, data){
        return dtsAPI.get(`DocumentType/DeliveryUnit/${data}`);
    },
    GetSingleDocumentType(context, data){
        return dtsAPI.get(`DocumentType/${data}`);
    },
    GetApprovalDocumentType(context, data){
        return dtsAPI.get(`DocumentType/Approval`);
    },
    GetApprovedDocumentType(context, data){
        return dtsAPI.get(`DocumentType/Approved`);
    },
    UpdateDocumentType(context, data){
        return dtsAPI.put(`DocumentType/${data.id}`, data);
    },
    DeleteDocumentType(context, data){
        return dtsAPI.delete(`DocumentType/${data}`);
    },
    CreateDocumentType(context, data){
        return dtsAPI.post(`DocumentType/${data.deliveryUnitId}`, data);
    },
    ApproveDocumentType(context, data){
        return dtsAPI.put(`DocumentType/Approve/${data}`);
    },

}